import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type { SetProfilerRequest } from './use-set-profiler.type';

const setProfiler = async ({ groupType, groupId }: SetProfilerRequest) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/set-profiler`;
  return request({
    url,
    method: RequestMethod.POST,
    body: groupType && groupId ? { groupType, groupId } : undefined,
    withCredentials: true,
  });
};

export const useSetProfiler = ({ options }: { options?: Record<string, boolean> } = {}) => {
  return useGenericMutation<{}, RequestError, SetProfilerRequest>(
    [QUERY_KEYS.setProfiler],
    async ({ groupType, groupId }: SetProfilerRequest) => setProfiler({ groupType, groupId }),
    options
  );
};
